import type { DisplayStatus, TicketStatus } from '@/types/ticket'
import type { TrackerStatus } from '@/types/tracker'
import { STAFF_SET_STATUSES, displayStatusLabels, statusLabels, trackerStatusLabels } from '@/lib/status'
import { railSelectClass } from './railSelect'

// Staff can set any stored status (Open, On Hold, Resolved, Closed); the derived ones show as the
// pill. A pre-migration status stays listed so it reads correctly until changed. A tracked ticket's
// status follows its tracker status instead.
export function StatusSelect({
  value,
  displayStatus,
  onChange,
  disabled,
  trackerStatus,
}: {
  value: TicketStatus
  /** The derived status the header pill shows; names the stored Open option so the two agree. */
  displayStatus?: DisplayStatus
  onChange: (s: TicketStatus) => void
  disabled?: boolean
  /** Present on a tracked ticket, whose status follows the tracker and can't be set here. */
  trackerStatus?: TrackerStatus
}) {
  const tracked = Boolean(trackerStatus)
  const options: TicketStatus[] = tracked ? [value] : STAFF_SET_STATUSES.includes(value) ? STAFF_SET_STATUSES : [value, ...STAFF_SET_STATUSES]
  const label = (s: TicketStatus) => {
    if (trackerStatus) return `Tracked · ${trackerStatusLabels[trackerStatus]}`
    return s === 'open' && value === 'open' && displayStatus ? displayStatusLabels[displayStatus] : statusLabels[s]
  }
  return (
    <select
      aria-label="Status"
      title={tracked ? 'Follows the tracker status' : undefined}
      disabled={disabled || tracked}
      value={value}
      onChange={e => onChange(e.target.value as TicketStatus)}
      className={railSelectClass}
    >
      {options.map(s => <option key={s} value={s}>{label(s)}</option>)}
    </select>
  )
}
